import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryWebsiteNews(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryNews(newsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news/${newsId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  links
 * @param  content
 * @param  contentImages
 * @param  tags
 * @param  description 描述
 * @param  type
 * @param  videoPath
 * @param  articleType
 * @param  shadePath
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addNews(
  {
    title,
    subTitle,
    postAt,
    brandId,
    coverPath,
    topImagePath,
    content,
    contentImages,
    links,
    tags,
    description,
    type,
    videoPath,
    articleType,
    shadePath,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news`,
    method: 'post',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      links,
      tags,
      description, // 描述
      type,
      videoPath,
      articleType,
      shadePath,
    },
  });
}

/**
 * 更新
 * @param newsId
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  content
 * @param  contentImages
 * @param  links
 * @param  description 描述
 * @param  type
 * @param  videoPath
 * @param  articleType
 * @param  shadePath
 * @param  tags
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateNews(newsId, {
  title,
  subTitle,
  postAt,
  brandId,
  coverPath,
  topImagePath,
  content,
  contentImages,
  links,
  tags,
  description,
  type,
  videoPath,
  articleType,
  shadePath,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news/${newsId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      links,
      tags,
      description, // 描述
      type,
      videoPath,
      articleType,
      shadePath
    },
  });
}

/**
 * 删除
 * @param newsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteNews(newsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news/${newsId}`,
    method: 'delete',
  });
}

export function _updateNewsSort({
  idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-news/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}
